export function ADD_ROOM(body = {}) {
    return {
        type: "ADD_ROOM",
        body
    };
};

export function UPDATE_ROOM(body = {}){
    return {
        type: "UPDATE_ROOM",
        body
    }
}

export function REMOVE_ROOM(body = {}){
    return {
        type: "REMOVE_ROOM",
        body
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/room.js